/* NaProsto, nagłówek: panel menu na telefonie i szuflada koszyka. Działa na każdej stronie z sekcją np-topbar. */
(function () {
  if (window.NPKoszyk) return;
  var SEC = 'np-koszyk';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cart = document.getElementById('np-cart');
  var menu = document.getElementById('np-menu');
  if (!cart) return;
  var lastFocus = null, busy = false;

  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function lock(on) { document.documentElement.classList.toggle('np-lock', on); }

  function setCount(n) {
    qa('[data-np-cart-count]').forEach(function (e) { e.textContent = n; e.hidden = !(n > 0); });
    qa('[data-np-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Koszyk, sztuk: ' + n); });
  }

  /* podmienia wnętrze szuflady na HTML z sekcji np-koszyk */
  function apply(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var inner = tmp.querySelector('[data-np-cart-inner]');
    var box = cart.querySelector('[data-np-cart-inner]');
    if (!inner || !box) return;
    box.parentNode.replaceChild(inner, box);
    setCount(parseInt(inner.getAttribute('data-count'), 10) || 0);
  }

  function refresh() {
    return fetch(ROOT + '?sections=' + SEC, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { apply(j[SEC]); })
      .catch(function () {});
  }

  function open() {
    closeMenu();
    lastFocus = document.activeElement;
    cart.classList.add('is-open');
    cart.setAttribute('aria-hidden', 'false');
    qa('[data-np-cart-open]').forEach(function (a) { a.setAttribute('aria-expanded', 'true'); });
    lock(true);
    var p = cart.querySelector('.np-cart__p');
    setTimeout(function () { if (p) p.focus({ preventScroll: true }); }, 30);
  }
  function close() {
    if (!cart.classList.contains('is-open')) return;
    cart.classList.remove('is-open');
    cart.setAttribute('aria-hidden', 'true');
    qa('[data-np-cart-open]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function openMenu() {
    if (!menu) return;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    qa('[data-np-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    lock(true);
    var x = menu.querySelector('.np-menu__x');
    setTimeout(function () { if (x) x.focus({ preventScroll: true }); }, 30);
  }
  function closeMenu() {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    qa('[data-np-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    lock(false);
  }

  function change(key, q) {
    if (busy) return;
    busy = true;
    cart.classList.add('is-busy');
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: q, sections: SEC })
    }).then(function (r) { return r.json(); })
      .then(function (j) { if (j.sections && j.sections[SEC]) apply(j.sections[SEC]); else return refresh(); })
      .catch(function () { return refresh(); })
      .then(function () { busy = false; cart.classList.remove('is-busy'); });
  }

  /* zamiana 1 sztuki na zestaw 2 sztuk: najpierw dodanie zestawu, potem usunięcie 1 sztuki, więc przy błędzie nic nie znika */
  function swap(key, to) {
    if (busy || !to) return;
    busy = true;
    cart.classList.add('is-busy');
    var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: to, quantity: 1 }] }) })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: key, quantity: 0, sections: SEC }) });
      })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.sections && j.sections[SEC]) apply(j.sections[SEC]); else return refresh(); })
      .catch(function () { return refresh(); })
      .then(function () { busy = false; cart.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target, b;
    if ((b = t.closest('[data-np-swap]'))) { e.preventDefault(); swap(b.getAttribute('data-np-swap'), parseInt(b.getAttribute('data-to'), 10)); return; }
    if ((b = t.closest('[data-np-cart-open]'))) { e.preventDefault(); open(); return; }
    if ((b = t.closest('[data-np-cart-close]'))) { e.preventDefault(); close(); return; }
    if ((b = t.closest('[data-np-qty]'))) { e.preventDefault(); change(b.getAttribute('data-np-qty'), parseInt(b.getAttribute('data-q'), 10) || 0); return; }
    if ((b = t.closest('[data-np-menu-open]'))) { e.preventDefault(); openMenu(); return; }
    if ((b = t.closest('[data-np-menu-close]'))) { e.preventDefault(); closeMenu(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') { close(); closeMenu(); }
  });
  /* powrót przyciskiem wstecz z kasy: stan koszyka mógł się zmienić */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.NPKoszyk = { open: open, close: close, apply: apply, refresh: refresh, setCount: setCount };
})();

/* Baner zgody Shopify (Customer Privacy API). Zapis zgody i przyciski zostają Shopify, motyw zmienia tylko wygląd
   (niski pasek, klasa np-ck w np.css) i tekst. Gdy układ banera jest inny niż oczekiwany, zostaje baner Shopify bez zmian.
   Pasek stoi nad przyklejonym przyciskiem koszyka, a jego wysokość trafia do --np-ck-h (odstęp w szufladzie koszyka). */
(function () {
  if (true) return;
  window.__npCk = true;
  var TXT = 'Używamy plików cookie, żeby sklep działał, do statystyk i żeby pokazywać Ci trafne reklamy.';
  var root = document.documentElement;

  function place(b) {
    var s = document.querySelector('[data-np-sticky]');
    /* pasek przyklejony jest position: fixed (offsetParent zawsze null), a na komputerze display: none */
    var off = (s && s.classList.contains('is-on') && getComputedStyle(s).display !== 'none') ? s.offsetHeight : 0;
    if (b.style.getPropertyValue('bottom') !== off + 'px') b.style.setProperty('bottom', off + 'px', 'important');
    var on = b.style.display !== 'none' && b.offsetHeight > 0;
    root.style.setProperty('--np-ck-h', on ? (b.offsetHeight + off) + 'px' : '0px');
  }

  function dress(b) {
    if (b.classList.contains('np-ck')) return true;
    var body = b.querySelector('.shopify-pc__banner__body');
    var acc = b.querySelector('#shopify-pc__banner__btn-accept');
    var dec = b.querySelector('#shopify-pc__banner__btn-decline');
    var pref = b.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!body || !acc || !dec) return false;
    var p = document.createElement('p');
    p.className = 'np-ck__t';
    p.appendChild(document.createTextNode(TXT + ' '));
    var a = document.createElement('button');
    a.type = 'button';
    a.className = 'np-ck__set';
    a.textContent = 'Ustawienia';
    a.setAttribute('aria-haspopup', 'dialog');
    /* „Ustawienia” uruchamia okno preferencji Shopify (ten sam przycisk co w oryginalnym banerze) */
    a.addEventListener('click', function () {
      if (pref) pref.click();
      else if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
    });
    p.appendChild(a);
    body.appendChild(p);
    acc.textContent = 'Akceptuję';
    dec.textContent = 'Odrzuć';
    b.classList.add('np-ck');
    place(b);
    new MutationObserver(function () { place(b); }).observe(b, { attributes: true, attributeFilter: ['style'] });
    var s = document.querySelector('[data-np-sticky]');
    if (s) new MutationObserver(function () { place(b); }).observe(s, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', function () { place(b); }, { passive: true });
    return true;
  }

  function tryDress() { var b = document.getElementById('shopify-pc__banner'); return !!(b && dress(b)); }
  if (tryDress()) return;
  var mo = new MutationObserver(function () { if (tryDress()) mo.disconnect(); });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 30000);
})();
